<!--
 * @Desc: 报名申请
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-02 18:39:37
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-apply">
        <div class="container">
            <div class="title">
                <img class="left" src="../../../public/statics/images/Apply/icon-desc.png" />
                <img src="../../../public/statics/images/Apply/title.png" />
                <img class="right" src="../../../public/statics/images/Apply/icon-desc.png" />
            </div>
            <div class="desc">
                <img src="../../../public/statics/images/Apply/desc.png" />
            </div>
            <div class="btn-apply" @click="$toPath('/Apply?active=15',{})">立即报名</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {},
    methods: {},
};
</script>

<style scoped>
.page-apply {
    width: 100%;
    height: 226px;
    background: url(../../../public/statics/images/Apply/icon-bg.jpg) center #002140;
    padding-top: 44px;
}
.page-apply .container .title {
    display: flex;
    justify-content: center;
}
.page-apply .container .title .left{
    margin-right: 15px;
}
.page-apply .container .title .right{
    margin-left: 15px;
}
.page-apply .container .desc {
    text-align: center;
    margin-top: 15px;
    margin-bottom: 33px;
}
.page-apply .container .btn-apply {
    width: 118px;
    line-height: 44px;
    background: #e22f24;
    margin: 0 auto;
    font-size: 14px;
    font-family: PingFangSC;
    color: #ffffff;
    text-align: center;
}
</style>
